import { Label } from '../ui/label'
import { Switch as SwitchUI } from '../ui/switch'
import { FormLabel } from './form-label'

export function Switch({
  field,
  label = 'Switch',
  id,
  name,
  required = false,
}: {
  field: any
  label?: string
  id?: string
  name?: string
  required?: boolean
}) {
  return (
    <>
      <FormLabel htmlFor={id || name}>
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </FormLabel>
      <div className="flex items-center space-x-2">
        <SwitchUI
          id={id || name}
          name={name}
          checked={!!field.state.value}
          onCheckedChange={field.handleChange}
          required={required}
        />
        <Label htmlFor="toggle-label" className="text-sm font-medium">
          {field.state.value ? 'Yes' : 'No'}
        </Label>
      </div>
      {field.state.meta.isTouched && !field.state.meta.isValid ? (
        <p className="text-xs text-red-500">
          {field.state.meta.errors.join(', ')}
        </p>
      ) : null}
      <p className="text-xs">
        {field.state.meta.isValidating ? 'Validating...' : null}
      </p>
    </>
  )
}
